<ng-container *transloco="let t">
  <div class="p-grid">
    <div class="p-col-fixed" style="width: 50px;">
      <app-avatar
        [user]="user"
        [type]="user.role"
        [mode]="'small'"
        [showStatus]="true"
      ></app-avatar>
    </div>
    <div class="p-col p-overflow-hidden">
      <span [class.offline]="!user?.isOnline()">{{ user.fullname }} <fa-icon *ngIf="user.role === 'observer' && user.type === 'silent'" [icon]="faCommentSlash" class="p-mr-2" [pTooltip]="t('common.labels.silent_observer')"></fa-icon></span>
      <ng-container *ngIf="user.role === 'moderator'">
        <span class="mod-info"><fa-icon [icon]="faEnvelope" class="p-mr-2"></fa-icon><a [attr.href]="'mailto:' + user.email">{{ user.email }}</a></span>
        <span *ngIf="user.phone" class="mod-info"><fa-icon [icon]="faPhone" class="p-mr-2"></fa-icon>{{ user.phone }}</span>
        <p-button *ngIf="auth.isModerator() && ac.informations_moderator !== null" (click)="showModeratorInfo()" [label]="t('common.labels.informations_moderator')" tabindex="0" [rounded]="true" severity="secondary" size="small" [styleClass]="'p-mt-2'"></p-button>
      </ng-container>
      <ng-container *ngIf="user.role !== 'moderator'">
        <span *ngIf="user?.isOnline()" class="mod-info">{{ t('common.labels.online') }}</span>
        <span *ngIf="!user?.isOnline()" class="mod-info offline">{{ t('common.labels.offline') }}</span>
      </ng-container>
      <ng-container *ngIf="app.hasFeature('runner.resultreport') && ac.isFinished() === true && auth.isModerator() === true && user.role === 'candidate'">
        <app-ai-report [ac]="ac" [candidate]="user" [report]="report" (reportChange)="onReportChanged($event)"></app-ai-report>
      </ng-container>
    </div>
    <div class="p-col-fixed p-text-right" style="width: 100px;">
      <button (click)="op.toggle($event)" pButton type="button" icon="pi pi-info-circle" class="p-button-sm p-button-secondary p-button-text"></button>
      <button *ngIf="items.length > 0" (click)="menu.toggle($event)" pButton type="button" icon="pi pi-bars" class="p-button-sm p-button-secondary p-button-text"></button>
      <p-overlayPanel #op [dismissable]="true">
        <div class="infos">
          <ul>
            <li *ngFor="let info of getInfos()">
              <i [attr.class]="info.icon"></i>{{ info.label }}: {{ info.value }}
            </li>
          </ul>
        </div>
      </p-overlayPanel>
      <p-menu #menu [popup]="true" [model]="items" appendTo="body"></p-menu>
    </div>
  </div>

  <input style="display: none" type="file" #fileInput (change)="onUploadAvatar(fileInput.files)" accept="image/*">

  <app-timezone-selector [(visible)]="timezoneSelectorVisible"></app-timezone-selector>
  <app-ac-move-selector
    *ngIf="candiateToMove !== null"
    [candidate]="candiateToMove"
    (cancelled)="onMoveCancel()"
    (moved)="onMoveDone()"
  ></app-ac-move-selector>

  <p-dialog [(visible)]="infoModeratorVisible" *ngIf="ac !== null && auth.isModerator() && ac.informations_moderator !== null" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="header">
      <h2 class="dialog">{{ t('common.labels.informations_moderator') }}</h2>
    </ng-template>
    <div [innerHTML]="ac.informations_moderator | nl2br"></div>
    <ng-template pTemplate="footer">
      <button class="p-button-sm" (click)="infoModeratorVisible=false" pButton type="button" icon="pi pi-check" label="{{ t('common.labels.ok') }}"></button>
    </ng-template>
  </p-dialog>

</ng-container>
